module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"More":"More"},"zh":{"More":"更多"},"mm":{"More":"နောက်ထပ်"}}')
  delete Component.options._Ctor
}
